import React, { createContext, useContext, useState } from "react";
import { ToastNotify } from "components/NotificationContainer";

export interface NotifyMessage {
    id: string;
    template?: "light_gray" | "dark_gray";
    description: string;
    hasButton?: boolean;
    buttonLabel?: string;
    onClickButton?: () => void;
}

interface NotifyContextData {
    addNotify(message: Omit<NotifyMessage, "id">): void;
    removeNotify(id: string): void;
}

const ToastNotifyContext = createContext<NotifyContextData>(
    {} as NotifyContextData
);

const ToastNotifyProvider: React.FC = ({ children }) => {
    const [messages, setMessages] = useState<NotifyMessage[]>([]);

    const addNotify = ({
        template,
        description,
        hasButton,
        buttonLabel,
        onClickButton,
    }: Omit<NotifyMessage, "id">) => {
        const id = String(Date.now());

        const notify = {
            id,
            template,
            description,
            hasButton,
            buttonLabel,
            onClickButton,
        };

        setMessages([notify]);
    };

    const removeNotify = (id: string) => {
        setMessages((oldState) =>
            oldState.filter((message) => message.id !== id)
        );
    };

    return (
        <ToastNotifyContext.Provider value={{ addNotify, removeNotify }}>
            {children}
            <ToastNotify messageNotify={messages} />
        </ToastNotifyContext.Provider>
    );
};

function useToastNotify(): NotifyContextData {
    const context = useContext(ToastNotifyContext);

    if (!context) {
        throw new Error(
            "useToastNotify shoud be used within a ToastNotifyProvider"
        );
    }

    return context;
}

export { ToastNotifyProvider, useToastNotify };
